import React ,{useEffect,useState} from 'react'
import LayoutCommercant from '../../Components/LayoutCommercant/LayoutCommercant'
import { GradientText ,FormSectionCard,Wrapper,	SubmitButtonContainer,SubmitButton} from '../PasserCommande/PasserCommande.styles'
import { useForm,Controller } from 'react-hook-form'
import { useSelector,useDispatch} from 'react-redux'
import toast from 'react-hot-toast'
import { CustomInput } from '../RegisterTransporter/style';
import { updateProfile } from '../../redux/auth'
import {getSingleCommercial,updateProfileCommercail} from '../../api/commerciaux'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { validatePhoneNumber } from '../../utils/phoneValidator'
function CommercantAccount() {
    const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
		control
	} = useForm()

	const dispatch = useDispatch()
    const { _id } = useSelector((state) => state.auth.user)
    const token = useSelector((state) => state.auth.token);
	const [chargementEnCours, setChargementEnCours] = useState(false);
    const [loading,setLoading]=useState(false)
	const [commercial,setCommercial]=useState(null)

	async function fetchCommercial(_id){
		setChargementEnCours(true)
		try {
			const data=await getSingleCommercial(_id,token)
			setCommercial(data)	
			reset({
				quality:data?.quality,
				address:data?.address,
				city:data?.city,
				postalCode:data?.postalCode,
				phone:data?.phone
			})
		} catch (error) {
			toast.error("Une erreur s'est produite", {
			style: {
			  fontFamily: 'Montserrat',
			},
		  });
		}finally{
			setChargementEnCours(false)
		}
		

	 } 
    useEffect(()=>{
       
          if(_id){
            fetchCommercial(_id)
          }
       
        },[_id])
        const onSubmit = async (data) => {
			setLoading(true)
          const update = {
                  address:data.address,
                  city:data.city,
                  postalCode:data.postalCode,
                  phone:data.phone,
                  password: data.password,
              }
          if (data.password.length === 0) {
                  delete data.password
                  delete update.password
              }
          try {
                  const res = await updateProfileCommercail(_id,update,token)
      
                  toast.success('Votre compte a été mis à jour', {
                      style: {
                          fontFamily: 'Montserrat',
                      },
                  })
				
      
                  dispatch(updateProfile(res))
              } catch (error) {
                  toast.error("Une erreur s'est produite", {
                      style: {
                          fontFamily: 'Montserrat',
                      },
                  })
              }finally{
				setLoading(false)
			  }
          }
  return (
    <LayoutCommercant>
        <Wrapper>
				<GradientText>MON COMPTE</GradientText>
		</Wrapper>
		{chargementEnCours ?
		<div
		style={{
		  display: 'flex',
		  alignItems: 'center',
		  justifyContent: 'center',
		  backgroundColor: 'white',
		  marginTop:"10rem"
		}}
		>
		<div className='customLoader'></div>	
		</div>
		:
        <div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
			>
                   <div
					style={{
						width: '65%',
						fontFamily: 'Montserrat',
						alignSelf: 'center',
					}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSectionCard>
                    <div
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								<div
									style={{
										width: '50%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										Nom
									</span>
									<CustomInput
										type='text'
                                        disabled
										defaultValue={commercial?.last_name}
										style={{
											backgroundColor: '#f0f0f0', 
											color: '#a9a9a9',           
											cursor: 'not-allowed'       
										}}
									/>
									
								</div>

								<div style={{ width: '1rem' }} />

								<div
									style={{
										width: '50%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										Prénom
									</span>
									<CustomInput
										type='text'
                                        disabled
										defaultValue={commercial?.first_name}
										style={{
											backgroundColor: '#f0f0f0', 
											color: '#a9a9a9',           
											cursor: 'not-allowed'       
										}}
									/>
									 
								</div>
	                </div>
                    <div
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								<div
									style={{
										width: '50%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										Téléphone
									</span>
										<Controller
											name="phone"
											control={control}
										    defaultValue={commercial?.phone}
									        rules={{
												validate: validatePhoneNumber
											}}
										    render={({ field }) => (
											<PhoneInput
											  country={'fr'}
										      value={field.value}
											  onChange={(phone, countryData) => {
													field.onChange(phone);
											  }}
											 inputProps={{
													name: field.name,
													required: true,
											}}
										    inputStyle={{
												paddingRight:'1.5rem',
												paddingTop:'1.5rem',
												paddingBottom:'1.5rem',
												borderRadius:'0.5rem',
												border: 'none',
												fontFamily:'Montserrat',
												color: '#858ea8',
												flex: '1',
											    display: 'flex',
												width: '100%',
											}}
										    buttonStyle={{
												borderRadius:'0.5rem',
												border: 'none',
												fontFamily:'Montserrat',
												color: '#858ea8',
												flex: '1',
											    display: 'flex',
											}}
																	
										    containerStyle={{
													 width: '100%',
									        }}
											placeholder="(0) 01 45 66 32 88"
											enableSearch={true}
											searchPlaceholder="Rechercher un pays"
											/>
										    )}
											 />
									
									{errors.phone && (
                                    <div style={{ color: 'red', marginTop: '0.5rem',fontSize:'14px' }}>
                                    {errors.phone.message}
                                    </div>
                               )}
									
								</div>

								<div style={{ width: '1rem' }} />

								<div
									style={{
										width: '50%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										Adresse email
									</span>
									<CustomInput
										type='text'
                                        disabled
										defaultValue={commercial?.email}
										style={{
											backgroundColor: '#f0f0f0', 
											color: '#a9a9a9',           
											cursor: 'not-allowed'       
										}}
									/>
									 
								</div>
	                </div>
					<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									Adresse
								</span>
								<Controller
                                    name="address"
                                    control={control}
									defaultValue={commercial?.address }
                                    rules={{
										required: ' Veuillez indiquer l\'adresse .',
										minLength: {
											value: 3,
											message: 'L\'adresse doit contenir au moins 3 caractères.',
										},
										pattern: {
											value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
											message: "L'adresse contient des caractères non autorisés.",

										},
                                    }}
                                    render={({ field }) => (
                                     <CustomInput
                                     type='text'
									 placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
                                      {...field} 
                                     />
                                    )}
                                    />
								{errors.address && (
                                <div style={{ color: 'red', marginTop: '0.5rem',fontSize:"14px" }}>
                                {errors.address.message}
                                 </div>
                                )}
				    </div>
					<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									Ville
								</span>
								<Controller
                                    name="city"
                                    control={control}
									defaultValue={commercial?.city}
                                    rules={{
										required: 'Veuillez indiquer la ville.',
										minLength: {
										   value: 3,
										   message: 'La ville doit contenir au moins 3 caractères.',
										 },
										 pattern: {
										   value: /^.+$/,
										   message: 'La ville doit contenir uniquement des lettres, des espaces, des apostrophes ou des tirets.',
										 },
                                    }}
                                    render={({ field }) => (
                                     <CustomInput
                                     type='text'
									 placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
                                      {...field} 
                                     />
                                    )}
                                    />
								{errors.city && (
                                <div style={{ color: 'red', marginTop: '0.5rem',fontSize:'14px' }}>
                                {errors.city.message}
                                </div>
                               )}
				    </div>
					<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									Code Postal 
							</span>
							<Controller
                                    name="postalCode"
                                    control={control}
									defaultValue={commercial?.postalCode}
                                    rules={{
										required: 'Veuillez indiquer le code postal.',
										pattern: {
											value: /^\d{5}$/,
											message: 'Le code postal doit contenir exactement 5 chiffres.',
										  },
                                    }}
                                    render={({ field }) => (
                                     <CustomInput
                                     type='text'
									 placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
                                      {...field} 
                                     />
                                    )}
                                    />
								{errors.postalCode && (
                                <div style={{ color: 'red', marginTop: '0.5rem',fontSize:'14px' }}>
                                {errors.postalCode.message}
                                </div>
                               )}
							</div>
                   
                
                    <div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									Réduction
								</span>
								<CustomInput
									type='text'
                                    disabled
									defaultValue={commercial?.reduction}
									style={{
										backgroundColor: '#f0f0f0', 
										color: '#a9a9a9',           
										cursor: 'not-allowed'       
									}}
								/>
								
				    </div>
                    <div
									style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										Changer mon mot de passe
									</span>
									<CustomInput
										type='password'
										{...register('password', {
											minLength: {
												value: 8,
												message: 'Le mot de passe doit contenir au moins 8 caractères',
													},
										})}
									/>
									{errors.password && (
                                    <div style={{ color: 'red', marginTop: '0.5rem',fontSize:'14px' }}>
                                    {errors.password.message}
                                    </div>
                               )}
								</div>
                    </FormSectionCard>
                    <div style={{ height: '1rem' }} />
				<SubmitButtonContainer>
					<SubmitButton type='submit' disabled={loading}>
					{loading ? (
									<div className='loader'></div>
								) : (
									'Enregistrer'
								)}
					</SubmitButton>
				</SubmitButtonContainer>
                    </form>
                    </div>
        </div>
        }
     
    </LayoutCommercant>
   
  )
}

export default CommercantAccount